import { EveAuthorizationService } from '@ver-uds/e-verify';
import { EverifyUserRole, User } from '@vis-auth/vis-user-client';
import { useAccount } from '../context/Account/AccountContext';
import { useUser } from '../context/User/UserContext';

const useEveAuthService = (): EveAuthorizationService => {
  const { roles } = useUser() as User;
  const { type, webServiceAccess } = useAccount();

  const eveAuthService = new EveAuthorizationService({
    userRoles: roles as EverifyUserRole[],
    accountType: type,
    webServiceAccess: webServiceAccess.enabled,
  });

  return eveAuthService;
};

export default useEveAuthService;
